import { invariant } from "@exonn/utils";
import type {
  CreateStockMoveFormMeta,
  CreateStockMoveRequestParams,
  CreateVariantRequestParams,
} from "src/framework/types.ts";
import { ResourceEnum } from "src/constants/constants.ts";

export const createResourceStorageKeys = ({
  resource,
}: {
  resource: string;
}) => {
  return {
    listState: {
      name: [resource, "list", "state"].join("."),
      version: "1",
    },
    listDataLoadingEnabled: {
      name: [resource, "list", "dataLoadingEnabled"].join("."),
      version: "1",
    },
    listRefreshIndex: {
      name: [resource, "list", "refreshIndex"].join("."),
      version: "1",
    },
    listExpandedRows: {
      name: [resource, "list", "expandedRows"].join("."),
      version: "1",
    },
    form: ({
      id,
      type,
      tab,
      requestParams,
      meta,
    }: {
      id?: string;
      type: "edit" | "create";
      tab?: string;
      requestParams?: Record<string, any>;
      meta?: any;
    }) => {
      invariant(
        type !== "edit" || !!id,
        "id must be specified for storage key of edit form",
      );

      const stockMoveRequestParams = requestParams as
        | CreateStockMoveRequestParams
        | undefined;

      const stockMoveMeta = meta as CreateStockMoveFormMeta | undefined;
      if (
        type === "create" &&
        resource === ResourceEnum.StockMove &&
        stockMoveMeta?.insideVariantForm &&
        stockMoveRequestParams
      ) {
        return {
          name: [
            resource,
            "form",
            type,
            stockMoveRequestParams.variant_sku,
          ].join("."),
          version: "4",
        };
      }

      const variantRequestParams = requestParams as
        | CreateVariantRequestParams
        | undefined;

      if (type === "create" && resource === ResourceEnum.Variant) {
        return {
          name: [resource, "form", type, variantRequestParams?.product_id].join(
            ".",
          ),
          version: "4",
        };
      }

      if (type === "create") {
        return {
          name: [resource, "form", type, id, tab ?? "general"].join("."),
          version: "4",
        };
      } else {
        return {
          name: [resource, "form", type, id, tab ?? "general"].join("."),
          version: "4",
        };
      }
    },
    formLang: ({
      id,
      type,
      tab,
    }: {
      id?: string;
      tab?: string;
      type: "edit" | "create";
      requestParams?: Record<string, any>;
      meta?: any;
    }) => {
      invariant(
        type !== "edit" || !!id,
        "id must be specified for storage key of edit form",
      );
      return {
        name: [resource, "form", type, id, tab ?? "general", "lang"].join("."),
        version: "4",
      };
    },
    tabs: {
      name: [resource, "tabs"].join("."),
      version: "1",
    },
  };
};
